import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useGetBannerbyIdQuery } from "../../../../Services/HomeAPI";
import { useParams } from "react-router-dom";

function AddCategory() {
  const { id } = useParams();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [isActive, setIsActive] = useState(1);
  const [buttonText, setButtonText] = useState("");
  const [buttonIsActive, setButtonIsActive] = useState(1);

  const {
    data: bannerDetail,
    isLoading: loadingContent,
    error,
    refetch: refetchBannerDetail,
  } = useGetBannerbyIdQuery(id);

  useEffect(() => {
    refetchBannerDetail();
  }, [refetchBannerDetail]);
  useEffect(() => {
    console.log(image);
  }, [image]);
  useEffect(() => {
    setTitle(bannerDetail?.title);
    setDescription(bannerDetail?.description);
    setIsActive(bannerDetail?.is_active);
    setButtonIsActive(bannerDetail?.button_is_active);
    setButtonText(bannerDetail?.button_text);
    console.log("bannerDetail", bannerDetail);
  }, [bannerDetail]);

  if (loadingContent) return <div class="loader"></div>;
  if (error) return <p>Failed to load Data</p>;

  return (
    <div>
      <h3>View Banner</h3>
      <div className="breadcrum mb-4">
        <p>
          <Link to="/home-banner-list">
            <span>Banner</span>
          </Link>
          <FontAwesomeIcon icon={faAngleRight} className="mx-2" />
          <span className="active-link">View</span>
        </p>
      </div>
      <div className="content-wrapper">
        <form>
          <div className="row">
            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Title</label>
                <input
                  type="text"
                  className="form-control"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Button Label</label>
                <input
                  type="text"
                  className="form-control"
                  value={buttonText}
                  onChange={(e) => setButtonText(e.target.value)}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Show/Hide Button</label>
                <select
                  className="form-control"
                  value={buttonIsActive}
                  onChange={(e) => setButtonIsActive(Number(e.target.value))}
                >
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </select>
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Show/Hide Banner</label>
                <select
                  className="form-control"
                  value={isActive}
                  onChange={(e) => setIsActive(Number(e.target.value))}
                >
                  <option value={1}>Active</option>
                  <option value={0}>Inactive</option>
                </select>
              </div>
            </div>
            <div className="col-md-12">
              <div className="mb-4 text-start">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control"
                  rows={4}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="mb-4 text-start">
                <label className="form-label">Image</label>
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => setImage(e.target.files[0])}
                />

                <img
                  src={bannerDetail?.desktop_image_url}
                  alt="banner-img"
                  width={200}
                  height={200}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddCategory;
